import { render, staticRenderFns } from "./OrderDeliveryDone.vue?vue&type=template&id=5da71b70&"
import script from "./OrderDeliveryDone.vue?vue&type=script&lang=ts&"
export * from "./OrderDeliveryDone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports